import { Input, Radio, RadioChangeEvent, Space } from 'antd';
import React, { useEffect, useState } from 'react';
import { User } from '../../types';

interface UserListFilterProps {
  unfilteredUserList: User[];
  setFilteredUserList: (users: User[]) => void;
  setFilterActive: (active: boolean) => void;
}

type FilterColumn = 'name' | 'email';

function UserListFilter(props: UserListFilterProps) {
  const [filterColumn, setFilterColumn] = useState<FilterColumn>('name');
  const [filterStr, setFilterStr] = useState('');

  const onFilter = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFilterStr(event.target.value);
  };

  useEffect(() => {
    if (filterStr === '') {
      props.setFilteredUserList([]);
      props.setFilterActive(false);
      return;
    }

    props.setFilterActive(true);
    props.setFilteredUserList(
      props.unfilteredUserList.filter((user) => {
        return user[filterColumn].toLowerCase().includes(filterStr.toLowerCase());
      }),
    );
  }, [filterStr, filterColumn, props.unfilteredUserList]);

  return (
    <>
      <Radio.Group
        onChange={(e: RadioChangeEvent) => setFilterColumn(e.target.value as FilterColumn)}
        defaultValue='name'
      >
        <Space.Compact>
          <Input placeholder={`Filter results by ${filterColumn}...`} onChange={onFilter} allowClear />
          <Radio.Button value='name'>Name</Radio.Button>
          <Radio.Button value='email'>Email</Radio.Button>
        </Space.Compact>
      </Radio.Group>
    </>
  );
}

export default UserListFilter;
